import { PartnerGroupRules, UserGroupRules } from 'src/graphql';

export enum ClientTabs {
  Sites = 'sites',
  Conversations = 'conversations',
  Activity = 'activity',
}

export type ClientTab = {
  label: string;
  value: ClientTabs;
  icon: string;
  allowedRules?: (UserGroupRules | PartnerGroupRules)[];
};

export const CLIENT_TABS: ClientTab[] = [
  {
    value: ClientTabs.Sites,
    label: 'Sites',
    icon: 'home',
  },
  {
    value: ClientTabs.Conversations,
    label: 'Conversations',
    icon: 'forum',
  },
  {
    value: ClientTabs.Activity,
    label: 'Activity',
    icon: 'schedule',
    allowedRules: [UserGroupRules.AccessToActivityFeedInClients],
  },
];
